/* jshint esversion: 6, -W097 */
/* globals require */
(function (angular) {
    'use strict';

    /*
    * Creates a modal that prompts the user to keep or replace their cart.
    */

    angular
        .module('enervee')
        .directive('replaceCartModal', replaceCartDirective)

    function replaceCartDirective() {
        return {
            restrict: 'E',
            scope: {},
            controllerAs: 'vm',
            bindToController: true,
            controller: replaceCartController,
            template: require('@app/shared/modals/replaceCart/replaceCart.html'),
        };
    }

    replaceCartController.$inject = [
        '$scope',
        '$window',
        'AnalyticsService',
        'CartService',
        'CmsContentService',
        'EnerveeCheckoutService',
        'IndexService',
    ];
    function replaceCartController(
        $scope,
        $window,
        AnalyticsService,
        CartService,
        CmsContentService,
        EnerveeCheckoutService,
        IndexService,
    ) {

        const vm = this;

        var processCMSData = function() {
            CmsContentService.getMarketPlaceText('base:modals:replace_cart_body_text',
                {
                    'partner_being_replaced': IndexService.getReplaceCartInfo().partnerBeingReplaced,
                    'partner_being_added': IndexService.getReplaceCartInfo().partnerBeingAdded
                }
            ).then(function(text) {
                vm.replace_cart_body_text = text;
            });
        };

        var modal = $('#replace-cart');

        modal.on('show.bs.modal', function() {
            processCMSData();
        });
        
        vm.replaceCart = function() {
            // Save the cardId of the cart getting replaced in session storage
            // then clear the existing cart
            $window.sessionStorage.abandonedCartId = CartService.cartDetails.cartId;
            EnerveeCheckoutService.clearCart();

            // Create a new cart with the product being added
            const product = IndexService.getReplaceCartInfo().productBeingAdded;
            EnerveeCheckoutService.addProductToCart(product.id, product.quantity).then(function() {
                IndexService.closeModal("#replace-cart");
            })
            AnalyticsService.reportEvent('Start New Order Clicked', {});
        }

        vm.onCloseModal = function () {
            AnalyticsService.reportEvent('Replace Cart Modal Dismissed', {});
        };
    }

})(angular);
